import React from 'react'
import {withRouter} from 'react-router'
import {connect} from 'react-redux'
import {
    Button,
    Checkbox,
    Col,
    Divider,
    Form,
    Input,
    InputNumber,
    message,
    PageHeader,
    Radio,
    Result,
    Row,
    Select,
    Spin,
    Typography,
    Upload
} from 'antd'
import {uploadImage, uploadResume} from '../../api/amazonS3'
import MediumCheckbox from '../../component/piece/MediumCheckbox'
import artEducationSmall from '../../asset/image/Art_Education-small.jpeg'
import commissionSmall from '../../asset/image/Commission-small.jpeg'
import immersiveExhibitionEventSmall from '../../asset/image/Immersive_Exhibition_Event_small.png'
import internationalArtworkSellingSmall from '../../asset/image/International_artwork_selling-small.jpeg'
import productSmall from '../../asset/image/Product-small.jpeg'
import spaceDesignSmall from '../../asset/image/Space_Design-small.jpeg'
import undecidedSmall from '../../asset/image/Undecided-small.jpeg'
import ArtStyleCheckbox from '../../component/piece/ArtStyleCheckbox'
import {FileDoneOutlined, UploadOutlined} from '@ant-design/icons'
import FormButton from '../../component/base/FormButton'
import {getUser, userApplyArtist} from '../../api/user'
import ApplyFormErrorMessage from '../../component/apply/ApplyFormErrorMessage'
import HttpError from '../../component/base/HttpError'
import {userUpdateArtistApply} from '../../action/user'
import {IN_PRODUCT} from '../../config/product'
import {getArtistPermission, patchArtistPermission} from "../../api/artists";
import {is_admin_user} from "../../app/role";
import {URL_DASHBOARD, URL_PIECES} from "../../const";

const {Title, Text} = Typography
const {Option} = Select

@connect(
    (state) => ({
        //decorator, gives component access to the state
        id: state.user.info.id,
        userId: state.user.info.userId,
        artistId: state.user.info.artistId,
        email: state.user.info.email,
        role: state.user.info.role,
        is_pending_approve: state.is_pending_approve,
        state: state
    }),
    {
        userUpdateArtistApply
    }
)
class Apply extends React.Component {
    constructor(props) {
        super(props)
        this.formRef = React.createRef()
        this.state = {
            validateError: [],
            loading: false,
            actionLoading: false,
            pseudonymInputVisible: false,
            fileList: [],
            is_pending_approve: this.props.is_pending_approve && this.props.is_pending_approve === true
        }
    }

    componentDidMount() {

        getArtistPermission(this.props.artistId).then((res) => {
            let is_pending_approve = res.data.is_pending_approve;
            if (res && is_pending_approve) {
                this.setState({is_pending_approve: true})
            }

            if (this.props.userId && !is_pending_approve) {
                getUser(this.props.userId)
                    .then(async (response) => {
                        const user = response.data
                        this.formRef.current.setFieldsValue({
                            email: user.email,
                            first_name: user.first_name,
                            lastName: user.last_name
                        })
                    })
                    .catch((error) => {
                        message.error(error.message).then(() => {
                        })
                    })

                if (this.formRef.current)
                    this.formRef.current.setFieldsValue({
                        name_select: 'realname'
                    })

                let cache = localStorage.getItem('applyForm' + this.props.userId)
                if (cache) {
                    let formData = JSON.parse(cache)
                    if (formData.name_select) {
                        if (formData.name_select === 'pseudonym') {
                            this.setState({
                                pseudonymInputVisible: true
                            })
                        }
                    }
                    if (formData.artwork_urls) {
                        this.setState({
                            fileList: formData.artwork_urls
                        })
                    }
                    if (this.formRef.current) this.formRef.current.setFieldsValue(formData)
                }

                if (IN_PRODUCT) {
                    const script = document.createElement('script')
                    script.src = '//js.hs-scripts.com/7839862.js'
                    script.async = true

                    document.body.appendChild(script)
                }
            }
        })
    }

    customRequest = (options) => {
        const {onError, onSuccess, file, onProgress} = options
        uploadImage(this.props.email, file, onSuccess, onError, onProgress)
    }

    customRequestResume = (options) => {
        const {onError, onSuccess, file, onProgress} = options
        uploadResume(this.props.email, file, onSuccess, onError, onProgress)
    }

    handleFormValuesChange = (changedValues, allValues) => {
        localStorage.setItem('applyForm' + this.props.userId, JSON.stringify(allValues))
    }

    onFinish = (values) => {
        if (!this.state.fileList || this.state.fileList.length < 5) {
            message.error('At least 5 artwork images should be uploaded').then(() => {
            })
            return
        }
        if (this.state.actionLoading) return;

        this.setState({validateError: [], loading: true})
        const {collaboration, medium, art_style} = values
        values['collaboration'] = collaboration.join(';')
        values['medium'] = medium.join(';')
        values['art_style'] = art_style.join(';')

        try {
            if (values.resume_url && values.resume_url.length > 0) {
                if (values.resume_url[0].response && values.resume_url[0].response.url) {
                    values['resume_url'] = values.resume_url[0].response.url
                }
            }
        } catch (error) {
            console.log(error)
        }

        let simple_artwork_urls = []
        this.state.fileList.map((item) => {
            simple_artwork_urls.push({
                response: {static_url: item.response.static_url, s3_url: item.response.s3_url},
                name: item.name,
                size: item.size
            })
        })
        values['artwork_urls'] = JSON.stringify(simple_artwork_urls)
        if (is_admin_user(this.props)) {
            values['user_id'] = this.props.userId
        }
        this.setState({actionLoading: true})

        patchArtistPermission(this.props.artistId, {is_pending_approve: true}).then(() => {
        }).catch((e) => {
            HttpError(e)
        })

        userApplyArtist(values)
            .then((r) => {
                this.props.userUpdateArtistApply({
                    is_pending_approve: true
                })
                message.success('You application has been received!').then(() => {
                })
                this.setState({
                    is_pending_approve: true
                }, ()=>{
                    setTimeout(()=>{
                        window.location.href = URL_DASHBOARD
                    }, 3000)
                })
            })
            .catch((e) => {
                HttpError(e)
            }).finally(() => {
            this.setState({actionLoading: false, loading: false})
        })
    }

    onFinishFailed = ({values, errorFields, outOfDate}) => {
        this.setState({validateError: errorFields})
        window.scrollTo(0, 0)
        window.scrollTop = 0
    }

    render() {
        function getApplyButton(ins) {
            return (
                <Button icon={<FileDoneOutlined/>} block type='primary' size='large' htmlType='submit'
                        loading={ins.state.actionLoading}>
                    Apply
                </Button>
            )
        }

        function getReceivedLayout() {
            return (
                <Result
                    status='success'
                    title='We have received your application for RevArt successfully!'
                    subTitle='We will get back to you as soon as possible.'
                    extra={[
                        <a key={0} className='button' href='mailto:contact@revart.co'>
                            Contact Us
                        </a>
                    ]}
                />
            )
        }

        if (this.state.is_pending_approve) {
            return getReceivedLayout()
        } else {
            return (
                <Spin size='large' spinning={this.state.loading}>
                    <PageHeader title={<Title>Application</Title>}/>
                    <ApplyFormErrorMessage error={this.state.validateError}/>
                    <Form
                        labelAlign='left'
                        style={{
                            marginTop: '16px',
                            padding: 24
                        }}
                        colon={false}
                        ref={this.formRef}
                        onValuesChange={this.handleFormValuesChange}
                        onFinish={this.onFinish}
                        onFinishFailed={this.onFinishFailed}
                    >
                        <Row justify='space-around' gutter={{xs: 8, sm: 16, md: 24}} wrap={true}>
                            <Col xs={24} sm={22} lg={11}>
                                <Title level={4}>Apply Now!</Title>
                                <p style={{fontStyle: 'italic', padding: 4}}>
                                    Apply for the RevArt artist program to gain access to exclusive exhibitions,
                                    licensing, and other collaboration
                                    opportunities with brands. If you have your artworks ready, the application should
                                    take between 10 and 20 minutes.
                                </p>
                                <p style={{padding: 4}}>Note: Your progress will automatically be saved and be kept
                                    confidential!</p>
                                <Divider orientation='left'>Basic Info</Divider>
                                <Form.Item initialValue={this.state.email} name='email' label='Email address'>
                                    <Input value={this.state.email} disabled/>
                                </Form.Item>
                                <Form.Item
                                    name='first_name'
                                    label='First name'
                                    rules={[
                                        {
                                            required: true,
                                            type: 'string',
                                            max: 100,
                                            min: 1
                                        }
                                    ]}
                                >
                                    <Input/>
                                </Form.Item>
                                <Form.Item
                                    name='middle_name'
                                    label='Middle Name'
                                    rules={[
                                        {
                                            type: 'string',
                                            max: 100,
                                            min: 1
                                        }
                                    ]}
                                >
                                    <Input/>
                                </Form.Item>
                                <Form.Item
                                    name='lastName'
                                    label='Last Name'
                                    rules={[
                                        {
                                            required: true,
                                            type: 'string',
                                            max: 100,
                                            min: 1
                                        }
                                    ]}
                                >
                                    <Input/>
                                </Form.Item>
                                <Form.Item name='name_select' label=' '>
                                    <Radio.Group
                                        buttonStyle='solid'
                                        onChange={(v) => {
                                            this.setState({pseudonymInputVisible: v.target.value === 'pseudonym'})
                                        }}
                                    >
                                        <Radio.Button value='realname'>Use my real name (recommend)</Radio.Button>
                                        <Radio.Button value='pseudonym'>Use a pseudonym</Radio.Button>
                                    </Radio.Group>
                                </Form.Item>
                                {this.state.pseudonymInputVisible === false ? null : (
                                    <Form.Item
                                        name='pseudonym'
                                        label='Pseudonym'
                                        rules={[
                                            {
                                                required: true,
                                                type: 'string',
                                                max: 100,
                                                min: 1
                                            }
                                        ]}
                                    >
                                        <Input/>
                                    </Form.Item>
                                )}
                                <Form.Item
                                    name='year_of_birth'
                                    label='Year of birth'
                                    rules={[
                                        {
                                            required: true
                                        }
                                    ]}
                                >
                                    <InputNumber/>
                                </Form.Item>
                                <Form.Item
                                    name='street'
                                    label='Street'
                                    rules={[
                                        {
                                            required: true,
                                            max: 100,
                                            min: 1
                                        }
                                    ]}
                                >
                                    <Input/>
                                </Form.Item>
                                <Form.Item
                                    name='zipcode'
                                    label='Zip code'
                                    rules={[
                                        {
                                            required: true,
                                            max: 100,
                                            min: 1
                                        }
                                    ]}
                                >
                                    <Input/>
                                </Form.Item>
                                <Form.Item
                                    name='city'
                                    label='City'
                                    rules={[
                                        {
                                            required: true,
                                            max: 100,
                                            min: 1
                                        }
                                    ]}
                                >
                                    <Input/>
                                </Form.Item>
                                <Form.Item
                                    name='state'
                                    label='State'
                                    rules={[
                                        {
                                            required: true,
                                            type: 'enum',
                                            enum: [
                                                'Not',
                                                'AK',
                                                'AL',
                                                'AR',
                                                'AS',
                                                'AZ',
                                                'CA',
                                                'CO',
                                                'CT',
                                                'DC',
                                                'DE',
                                                'FL',
                                                'GA',
                                                'GU',
                                                'HI',
                                                'IA',
                                                'ID',
                                                'IL',
                                                'IN',
                                                'KS',
                                                'KY',
                                                'LA',
                                                'MA',
                                                'MD',
                                                'ME',
                                                'MI',
                                                'MN',
                                                'MO',
                                                'MP',
                                                'MS',
                                                'MT',
                                                'NA',
                                                'NC',
                                                'ND',
                                                'NE',
                                                'NH',
                                                'NJ',
                                                'NM',
                                                'NV',
                                                'NY',
                                                'OH',
                                                'OK',
                                                'OR',
                                                'PA',
                                                'PR',
                                                'RI',
                                                'SC',
                                                'SD',
                                                'TN',
                                                'TX',
                                                'UT',
                                                'VA',
                                                'VI',
                                                'VT',
                                                'WA',
                                                'WI',
                                                'WV',
                                                'WY'
                                            ]
                                        }
                                    ]}
                                >
                                    <Select showSearch>
                                        <Option value='Not'>Not in the (US)</Option>
                                        <Option value='AK'>Alaska</Option>
                                        <Option value='AL'>Alabama</Option>
                                        <Option value='AR'>Arkansas</Option>
                                        <Option value='AS'>American Samoa</Option>
                                        <Option value='AZ'>Arizona</Option>
                                        <Option value='CA'>California</Option>
                                        <Option value='CO'>Colorado</Option>
                                        <Option value='CT'>Connecticut</Option>
                                        <Option value='DC'>District of Columbia</Option>
                                        <Option value='DE'>Delaware</Option>
                                        <Option value='FL'>Florida</Option>
                                        <Option value='GA'>Georgia</Option>
                                        <Option value='GU'>Guam</Option>
                                        <Option value='HI'>Hawaii</Option>
                                        <Option value='IA'>Iowa</Option>
                                        <Option value='ID'>Idaho</Option>
                                        <Option value='IL'>Illinois</Option>
                                        <Option value='IN'>Indiana</Option>
                                        <Option value='KS'>Kansas</Option>
                                        <Option value='KY'>Kentucky</Option>
                                        <Option value='LA'>Louisiana</Option>
                                        <Option value='MA'>Massachusetts</Option>
                                        <Option value='MD'>Maryland</Option>
                                        <Option value='ME'>Maine</Option>
                                        <Option value='MI'>Michigan</Option>
                                        <Option value='MN'>Minnesota</Option>
                                        <Option value='MO'>Missouri</Option>
                                        <Option value='MP'>Northern Mariana Islands</Option>
                                        <Option value='MS'>Mississippi</Option>
                                        <Option value='MT'>Montana</Option>
                                        <Option value='NA'>National</Option>
                                        <Option value='NC'>North Carolina</Option>
                                        <Option value='ND'>North Dakota</Option>
                                        <Option value='NE'>Nebraska</Option>
                                        <Option value='NH'>New Hampshire</Option>
                                        <Option value='NJ'>New Jersey</Option>
                                        <Option value='NM'>New Mexico</Option>
                                        <Option value='NV'>Nevada</Option>
                                        <Option value='NY'>New York</Option>
                                        <Option value='OH'>Ohio</Option>
                                        <Option value='OK'>Oklahoma</Option>
                                        <Option value='OR'>Oregon</Option>
                                        <Option value='PA'>Pennsylvania</Option>
                                        <Option value='PR'>Puerto Rico</Option>
                                        <Option value='RI'>Rhode Island</Option>
                                        <Option value='SC'>South Carolina</Option>
                                        <Option value='SD'>South Dakota</Option>
                                        <Option value='TN'>Tennessee</Option>
                                        <Option value='TX'>Texas</Option>
                                        <Option value='UT'>Utah</Option>
                                        <Option value='VA'>Virginia</Option>
                                        <Option value='VI'>Virgin Islands</Option>
                                        <Option value='VT'>Vermont</Option>
                                        <Option value='WA'>Washington</Option>
                                        <Option value='WI'>Wisconsin</Option>
                                        <Option value='WV'>West Virginia</Option>
                                        <Option value='WY'>Wyoming</Option>
                                    </Select>
                                </Form.Item>
                                <Form.Item
                                    name='country'
                                    label='Country'
                                    rules={[
                                        {
                                            required: true,
                                            max: 100,
                                            min: 1
                                        }
                                    ]}
                                >
                                    <Input/>
                                </Form.Item>
                                <Form.Item
                                    name='phone'
                                    label='Phone number'
                                    rules={[
                                        {
                                            required: true,
                                            max: 100,
                                            min: 1
                                        }
                                    ]}
                                >
                                    <Input/>
                                </Form.Item>

                                <div className='rightContainer'>
                                    <Form.Item
                                        name='artwork_urls'
                                        label='upload at least five and up to twenty clear artwork images'
                                        valuePropName='fileList'
                                        getValueFromEvent={(e) => {
                                            return e && e.fileList
                                        }}
                                        rules={[
                                            {
                                                required: true
                                            }
                                        ]}
                                        noStyle
                                    >
                                        <Divider orientation='left'>
                                            <span style={{color: 'red'}}>*</span> Artwork Upload
                                            ({this.state.fileList.length})
                                        </Divider>
                                        <Upload.Dragger
                                            multiple={true}
                                            accept='image/*'
                                            listType='picture'
                                            customRequest={this.customRequest}
                                            maxCount={12}
                                            fileList={this.state.fileList}
                                            onChange={({fileList: newFileList}) => {
                                                this.setState({fileList: newFileList}, this.formRef.current.setFieldsValue({artwork_urls: newFileList}))
                                                let cacheFileList = newFileList.map((v) => {
                                                    if (v.response) v['thumbUrl'] = v.response.static_url
                                                    return v
                                                })
                                                this.handleFormValuesChange({artwork_urls: cacheFileList}, this.formRef.current.getFieldsValue())
                                            }}
                                        >
                                            <div className='uploadDraggerContainer'>
                                                <Button type='primary'> Choose File</Button>
                                                <Text type='secondary' style={{alignSelf: 'flex-start'}}>
                                                    Notes:
                                                </Text>
                                                <Text type='secondary' style={{alignSelf: 'flex-start'}}>
                                                    Please upload at least five and up to twenty clear artwork images
                                                    for the vetting process.
                                                </Text>
                                                <Text type='secondary' style={{alignSelf: 'flex-start'}}>
                                                    We accept images in most formats. Each image should be at least 250
                                                    KB and cannot exceed 10 MB.
                                                </Text>
                                                <Text type='secondary' style={{alignSelf: 'flex-start'}}>
                                                    Well lit, true to color, and in focus. The pictures in high quality
                                                    will help you pass the vetting process.
                                                </Text>
                                            </div>
                                        </Upload.Dragger>
                                    </Form.Item>
                                    <Divider orientation='left'>
                                        <span style={{color: 'red'}}>*</span> Collaboration Preferences
                                    </Divider>

                                    <Form.Item
                                        name='collaboration'
                                        label={'Collaboration Preferences'}
                                        rules={[
                                            {
                                                required: true
                                            }
                                        ]}
                                        style={{
                                            wordWrap: 'break-word',
                                            whiteSpace: 'pre-wrap'
                                        }}
                                        errors={['Please select the collaboration']}
                                        noStyle
                                    >
                                        <Checkbox.Group>
                                            <Row justify='space-between'>
                                                <Col className='medium-picture'>
                                                    <img src={artEducationSmall} alt='Painting'/>
                                                    <Checkbox value='art-education'>Art Education</Checkbox>
                                                </Col>
                                                <Col className='medium-picture'>
                                                    <img src={commissionSmall} alt='Drawing'/>
                                                    <Checkbox value='commission'>Commission</Checkbox>
                                                </Col>
                                                <Col className='medium-picture'>
                                                    <img src={immersiveExhibitionEventSmall} alt='Sculpture'/>
                                                    <Checkbox value='immersive-exhibition-event'>Immersive Exhibition
                                                        Event</Checkbox>
                                                </Col>
                                                <Col className='medium-picture'>
                                                    <img src={internationalArtworkSellingSmall} alt='Collage'/>
                                                    <Checkbox value='international-artwork-selling'>International
                                                        Artwork Selling</Checkbox>
                                                </Col>
                                                <Col className='medium-picture'>
                                                    <img src={productSmall} alt='Installation & Digital'/>
                                                    <Checkbox value='product'>Product</Checkbox>
                                                </Col>
                                                <Col className='medium-picture'>
                                                    <img src={spaceDesignSmall} alt='Mixed Media'/>
                                                    <Checkbox value='space-design'>Space Design</Checkbox>
                                                </Col>
                                                <Col className='medium-picture'>
                                                    <img src={undecidedSmall} alt='Mixed Media'/>
                                                    <Checkbox value='undecided'>Undecided</Checkbox>
                                                </Col>
                                            </Row>
                                        </Checkbox.Group>
                                    </Form.Item>
                                    <Divider orientation='left'>Connect with Us</Divider>
                                    <Form.Item
                                        name='hear_us'
                                        label={'How did you hear us?'}
                                        rules={[
                                            {
                                                required: true
                                            }
                                        ]}
                                    >
                                        <Select placeholder='How did you hear us?'>
                                            <Option value='direct-contact'>Contacted by our agents</Option>
                                            <Option value='artist-friend'>Artist friends</Option>
                                            <Option value='art-lover-friends'>Art lover friends</Option>
                                            <Option value='linkedin'>LinkedIn</Option>
                                            <Option value='facebook'>Facebook</Option>
                                            <Option value='instagram'>Instagram</Option>
                                            <Option value='google'>Google</Option>
                                            <Option value='blogs-materials'>Blogs / Learning materials</Option>
                                            <Option value='events'>Events</Option>
                                            <Option value='art-organizations'>Art Organizations and Schools</Option>
                                            <Option value='others'>Others</Option>
                                        </Select>
                                    </Form.Item>
                                    <Form.Item
                                        name='referral'
                                        label={'Referral'}
                                        rules={[
                                            {
                                                required: false
                                            }
                                        ]}
                                    >
                                        <Input placeholder={'Do you have a referral? If yes, please let us know.'}/>
                                    </Form.Item>
                                    <Form.Item
                                        name='invite_code'
                                        label={'Invite Code'}
                                        rules={[
                                            {
                                                required: false
                                            }
                                        ]}
                                    >
                                        <Input placeholder={'Do you have an invitation code?'}/>
                                    </Form.Item>
                                    <Form.Item
                                        name='feedbacks'
                                        label={'feedbacks'}
                                        rules={[
                                            {
                                                required: false
                                            }
                                        ]}
                                    >
                                        <Input.TextArea showCount maxLength={20480}
                                                        autoSize={{minRows: 4, maxRows: 4}}/>
                                    </Form.Item>
                                </div>
                            </Col>
                            <Col xs={24} sm={22} lg={11}>
                                <Divider orientation='left'>Artist Profile</Divider>

                                <Form.Item
                                    name='art_style'
                                    label='Art style'
                                    rules={[
                                        {
                                            required: true
                                        }
                                    ]}
                                >
                                    <ArtStyleCheckbox/>
                                </Form.Item>
                                <Form.Item
                                    name='medium'
                                    label='Medium'
                                    rules={[
                                        {
                                            required: true
                                        }
                                    ]}
                                >
                                    <MediumCheckbox/>
                                </Form.Item>
                                <Form.Item
                                    name='years_in_career'
                                    label='Years in the career'
                                    rules={[
                                        {
                                            required: true
                                        }
                                    ]}
                                >
                                    <InputNumber/>
                                </Form.Item>
                                <Form.Item
                                    name='resume_url'
                                    label='Resume'
                                    valuePropName='fileList'
                                    extra={'If you have a resume, please upload it here.'}
                                    getValueFromEvent={(e) => {
                                        if (Array.isArray(e)) {
                                            return e
                                        }
                                        return e && e.fileList
                                    }}
                                >
                                    <Upload accept={'*'} listType='text' maxCount={1}
                                            customRequest={this.customRequestResume}>
                                        <Button icon={<UploadOutlined/>}>Click to upload</Button>
                                    </Upload>
                                </Form.Item>
                                <Divider orientation='left'>Artist statement</Divider>

                                <Form.Item
                                    name='art_statement'
                                    rules={[
                                        {
                                            required: true,
                                            type: 'string',
                                            max: 20480,
                                            min: 1
                                        }
                                    ]}
                                    label='Art Statement'
                                    wrapperCol={{span: 18}}
                                    labelCol={{span: 6}}
                                    extra={
                                        <p>
                                            An artist statement may include
                                            <br/>
                                            1. What led you to your career as an artist？
                                            <br/>
                                            2. Why do you create a specific type of art？
                                            <br/>
                                            3. Where do you find inspiration？
                                            <br/>
                                            4. Which other artists or movements influence your work most？
                                            <br/>
                                            5. What are your intentions for the work?
                                            <br/>
                                            6. Where do you see yourself as an artist in the future?
                                            <br/>
                                            7. What do you want your fans to know?
                                        </p>
                                    }
                                >
                                    <Input.TextArea showCount maxLength={20480} autoSize={{minRows: 24, maxRows: 24}}/>
                                </Form.Item>

                                <Divider orientation='left'>Social Media Links</Divider>
                                <Text type='secondary'>If you have any social media links, please share them with
                                    us.</Text>
                                <Form.Item
                                    label='Personal Website'
                                    name='social_website'
                                    rules={[
                                        {
                                            type: 'string',
                                            max: 100,
                                            min: 1
                                        }
                                    ]}
                                >
                                    <Input/>
                                </Form.Item>
                                <Form.Item
                                    label='Facebook'
                                    name='social_facebook'
                                    rules={[
                                        {
                                            type: 'string',
                                            max: 100,
                                            min: 1
                                        }
                                    ]}
                                >
                                    <Input/>
                                </Form.Item>
                                <Form.Item
                                    label='Instagram'
                                    name='social_instagram'
                                    rules={[
                                        {
                                            type: 'string',
                                            max: 100,
                                            min: 1
                                        }
                                    ]}
                                >
                                    <Input/>
                                </Form.Item>
                                <Form.Item
                                    label='Linkedln'
                                    name='social_linkedin'
                                    rules={[
                                        {
                                            type: 'string',
                                            max: 100,
                                            min: 1
                                        }
                                    ]}
                                >
                                    <Input/>
                                </Form.Item>
                            </Col>
                        </Row>
                        <FormButton>
                            <Col span={12} offset={6}>
                                {getApplyButton(this)}
                            </Col>
                        </FormButton>
                    </Form>
                </Spin>
            )
        }
    }
}

export default withRouter(Apply)
